import calls from '@/backend/api-calls'

const state = () => ({
  installationItems: [],
  selected: [],
  allSelected: false,
  loading: false,
  firstLoad: true,
  project: null,
  filters: {
    project_id: null,
    skid_no: null,
    piece_no: null,
    is_sent: true,
    no_status: false,
    status: null
  },
  pagination: {
    page: 1,
    pages: 1
  }
})


const getters = {
  ids: state => {
    return state.installationItems.map(d => d.id);
  }
}


const actions = {
  getInstallationItems: ({commit}, parameters) => {
    commit("setLoading", true);

    return new Promise((resolve, reject) => {
      calls.installationItems.get(parameters)
        .then(resp => {
          commit("setInstallationItems", resp.data);
          commit("setLoading", false);
          commit("setFirstLoad", false);
          resolve(resp);
        }).catch(err => {
          commit("setLoading", false);
          reject(err);
        })
    })
  },
  updateInstallationItem: ({commit}, { installationItemId, data }) => {
    commit("setLoading", true);

    return new Promise((resolve, reject) => {
      calls.installationItem.put(installationItemId, data)
        .then(resp => {
          commit("insertUpdatedInstallationItem", resp.data);
          commit("setLoading", false);
          commit("setFirstLoad", false);
          resolve(resp);
        }).catch(err => {
          commit("setLoading", false);
          reject(err);
        })
    })
  },
  addAttachment: ({commit}, { installationItemId, data }) => {
    return new Promise((resolve, reject) => {
      calls.installationItem.addAttachment(installationItemId, data)
        .then(resp => {
          commit("insertUpdatedInstallationItem", resp.data);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  // addInstallationItem({commit}, { data, parameters }) {
  //   return new Promise((resolve, reject) => {
  //     calls.intallationItems.post(data, parameters)
  //       .then(resp => {
  //         commit("insertInstallationItem", resp.data);
  //         resolve(resp);
  //       }).catch(err => {
  //         reject(err);
  //       })
  //   })
  // },
  // deleteInstallationItem: ({commit}, installationItemId) => {
  //   return new Promise((resolve, reject) => {
  //     calls.packingList.delete(packingListId).then(
  //       resp => {
  //         commit("removePackingList", packingListId);
  //         commit("app/setNotification", {
  //           type: 'success',
  //           status: true,
  //           message: 'Packing list successfully deleted'
  //         }, { root: true });

  //         resolve(resp);
  //       }
  //     ).catch(err => reject(err));
  //   })
  // },
  toggleAllSelected: ({commit, getters}, value) => {
    if (value) {
      commit("selectAll", getters.ids);
    } else {
      commit("deselectAll");
    }
  }
}


const mutations = {
  setLoading(state, status) {
    state.loading = status;
  },
  setFirstLoad(state, status) {
    state.firstLoad = status;
  },
  setInstallationItems(state, data) {
    state.pagination = data.pagination;
    state.installationItems = data.results;
  },
  insertUpdatedInstallationItem(state, data) {
    state.installationItems.forEach((installationItem, i) => {
      if (installationItem.id == data.id) {
        state.installationItems.splice(i, 1, data);
      }
    })
  },
  // insertPackingList(state, data) {
  //   state.packingLists.push(data);
  // },
  // removePackingList(state, packingListId) {
  //   state.packingLists.forEach((packingList, i) => {
  //     if (packingList.id == packingListId) {
  //       state.packingLists.splice(i, 1);
  //     }
  //     const index = state.selected.indexOf(packingListId);
  //     if (index != -1) {
  //       state.selected.splice(index, 1);
  //     }
  //   })
  // },
  changePage(state, page) {
    state.pagination.page = page;
  },
  setFilter(state, { field, value }) {
    state.filters[field] = value;
  },
  selectAll(state, ids) {
    state.allSelected = true;
    ids.forEach(id => {
      if (state.selected.indexOf(id) == -1) {
        state.selected.push(id);
      }
    })
  },
  deselectAll(state) {
    state.allSelected = false;
    state.selected.splice(0, state.selected.length)
  },
  toggleSelected(state, id) {
    const index = state.selected.indexOf(id);

    if (index == -1) {
      state.selected.push(id);
    } else {
      state.selected.splice(index, 1);
      if (state.selected.length == 0) {
        state.allSelected = false;
      }
    }
  },
  setProject(state, value) {
    state.project = value;
  }
}


export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}